import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import ContactFormCmp from "../../components/ContactFormCmp";

const BuildingConstruction = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        location: "",
        budget: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const submitMessage = (e) => {
        e.preventDefault();
        // console.log(formData);
        // API call or validation logic here
        alert(
            'Due to some technical issues, we could not process your Form Submission.'
        );

        setFormData({
            fullName: "",
            email: "",
            phone: "",
            location: "",
            budget: "",
            message: "",
        });
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <>
            {/*Start breadcrumb area paroller*/}
            <section className="breadcrumb-area">
                <div className="breadcrumb-area-bg" style={{ backgroundImage: 'url(/assets/images/services/banners/BuildingServices.jpg)' }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="inner-content">
                                <div className="title">
                                    <h2>Building Construction</h2>
                                </div>
                                <div className="breadcrumb-menu">
                                    <ul>
                                        <li><Link to="/">Home</Link></li>
                                        <li><i className="fa fa-angle-right" aria-hidden="true" /></li>
                                        <li className="active">Building Construction</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*End breadcrumb area*/}

            <div className="service-details-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="service-details-sec1">
                                <div className="d-flex">
                                    <div className="flex-shrink-0">
                                        <img className="serv-im" src="/assets/images/Group2.png" alt="Architecture Design" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h3 className="serv-head">Building Construction</h3>
                                        <p className="serv-txt">Our construction services cover the entire building process, from planning to approval & foundation to
                                            finishing, ensuring quality work delivered on time and within budget.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="serv-sec2">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="serv-sec2-leftsec">
                                    <h3 className="serv-sec2-leftsec-head">What We Offer</h3>
                                    <p className="serv-sec2-leftsec-txt">Our construction services cover the entire building process from foundation to finishing. With a dedicated project management team, we ensure every phase is executed with precision, within budget, and on schedule.</p>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Building Plan Approvals</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Working Drawing + Structural Designs</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Material Constructions</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Construction Supervision</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Valuations</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">All Commercial Construction Activities</p>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="serv-sec-3box">
                                        <h3 className="serv-sec-3box-head">Our Construction Process</h3>
                                        <ul className="serv-sec-3box-ul">
                                            <li>1. Initial consultation and site assessment</li>
                                            <li>2. Detailed project planning and budgeting</li>
                                            <li>3. Material selection and procurement</li>
                                            <li>4. Construction execution with quality checks</li>
                                            <li>5. Final inspection and handover</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='contactus-section2Right'>
                                    <h3 className='contactus-section2RightHead'>Contact for Service</h3>
                                    <p className='contactus-section2Righttxt'>Fill in your details and we'll get back to you within 24 hours.</p>
                                    <ContactFormCmp serviceName="Building" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default BuildingConstruction;